import { createBlock } from '@wordpress/blocks';
const transforms = {
    from: [
        {
            type: 'block',
            isMultiBlock: true, // Enable multi-block transformation
            blocks: ['*'], // Allow transforming any blocks
            __experimentalConvert(blocks) {
                return createBlock(
                    'vayu-blocks/advance-container', 
                    {}, 
                    blocks.map(block => createBlock(block.name, block.attributes, block.innerBlocks))
                );
            },
        },
    ],
};

export default transforms;